<template>
  <div class="my-nav">
    <!-- <div></div> -->
    <!-- style="background-color: transparent;" -->
    <nav class="navbar navbar-default" id="nav-bac">
      <div class="container-fluid mycustom">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <!-- <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
            <span class="sr-only">因美优品</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button> -->
          <span class="menuBtn" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1"
                aria-expanded="false"></span>
          <a class="navbar-brand" href="#">

            <router-link to="/index" style="display: flex;align-items: center;">
              <img src="../../assets/images/header/logo.png" class="logo" alt="">
              <span class="brand-span">钰 狮 科 技</span>
            </router-link>
          </a>
        </div>
        <!--  style="position: absolute;left: 10%;width: 1px;height: 40px;" -->

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1" @click="shows"
             :class="{'aaaa':show==false}">

          <ul class="nav navbar-nav items" id="bacright">

            <!--首页-->
            <li class="" index='0'>
              <router-link to="/index">首页</router-link>
            </li>
            <!--游戏-->
            <li class="" index='1'>
              <router-link to="/xwzx">产品及解决方案</router-link>
            </li>
            <!--加入我们-->
            <li index='2'>
              <router-link to="/contact">联系我们</router-link>
            </li>
            <!--关于我们-->
            <!-- <li index='3'>
              <router-link to="/about">关于我们</router-link>
            </li> -->

          </ul>

          <!--<form class="navbar-form navbar-left">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Search">
            </div>
            <button type="submit" class="btn btn-default">Submit</button>
          </form>-->

        </div>

      </div>
      <div class="col-lg-2 col-md-2 col-xs-2"></div>
    </nav>


  </div>
</template>

<script>
import userEqu from '../../assets/Device.js'

export default {
  data() {
    return {
      show: false,
      //   路由path与activeIndex映射
      routeMap: {
        '0': '/index',
        '1': '/xwzx',
        '2': '/contact',
      }
    }
  },
  mounted() {
    this.chengePath();

  },
  methods: {
    //根据路由path改变activeIndex
    shows() {
      this.show = !this.show
      $(".menuBtn").removeClass("open");
    },
    chengePath() {
      let path = this.$route.path;

      for (let key in this.routeMap) {
        // console.log(this.routeMap[key]);输出网址
        if (path.indexOf(this.routeMap[key]) != -1) {
          this.setNavStyle(key)
          // $(".menuBtn").removeClass("open");
        }
      }
    },
    setNavStyle(index) {
      if (!document.querySelectorAll('ul.navbar-nav.items>li')) return;
      document.querySelectorAll('ul.navbar-nav.items>li').forEach(v => {

        if (v.getAttribute('index') == index) {
          v.classList.add('active')

        } else {
          v.classList.remove('active')

        }
      })
    }
  },
  watch: {
    '$route.path': 'chengePath'
  },
  created() {
    // console.log(userEqu,"leixing")

    this.chengePath();


    $(document).ready(function ($) {
      var _winw = $(window).width();
      // 手机导航
      $('.menuBtn').append('<b></b><b></b><b></b>');
      $('.menuBtn').click(function (event) {

        $(this).toggleClass('open');
        $('.hd-body').stop().slideToggle();
      });

      if (_winw > 768) {
        $('.nav li').hover(function () {
          $(this).addClass('on');
          if ($(this).find('.sub').length) {
            $(this).find('.sub').stop().slideDown(200);
          }
        }, function () {
          $(this).removeClass('on');
          $(this).find('.sub').stop().slideUp(200);
        });
        $('.nav .third').hover(function () {
          if ($(this).find('.drop').length) {
            $(this).find('.drop').stop().slideDown(200);
          }
        }, function () {
          $(this).removeClass('on');
          $(this).find('.drop').stop().slideUp(200);
        });

      } else {
        $('.nav li').unbind('mouseenter mouseleave')
        $('.nav li>.dropIcon').click(function () {

          $(this).parents('li').find('.sub').stop().slideToggle().parents('li').toggleClass('on').siblings('li').removeClass('on').find('.sub').stop().slideUp();
        });
        $('.nav .sub .dropIcon').click(function () {

          $(this).parents('.third').find('.drop').stop().slideToggle().parents('.third').toggleClass('on').siblings('.third').removeClass('on').find('.drop').stop().slideUp();
        });
      }
      // 头部动态加类
      var header = $('.header'),
        headerH = header.height(),
        initScrh = $(window).scrollTop();

      function changeHeader(scrH) {
        if (scrH > headerH) {
          header.addClass('fixed');
        } else {
          header.removeClass('fixed');
        }
      }

      changeHeader(initScrh);
      $(window).on('scroll', function () {
        var _scrH = $(window).scrollTop();
        if ($(window).width() > 768) {
          changeHeader(_scrH);
        } else {
          header.removeClass('fixed');
        }
      });

      // 选项卡 鼠标点击
      // $(".TAB_CLICK li").click(function () {
      //     var tab = $(this).parent(".TAB_CLICK");
      //     var con = tab.attr("id");
      //     var on = tab.find("li").index(this);
      //     $(this).addClass('on').siblings(tab.find("li")).removeClass('on');
      //     $(con).eq(on).show().siblings(con).hide();
      // });
      $('.TAB_CLICK').each(function (index, el) {
        if ($(this).find('li.on').length) {
          $(this).find("li.on").trigger('click');
        } else {
          $(this).find("li").filter(':first').trigger('click');
        }
      });
      $('.header .so').click(function () {

        var _curPop = $(this).attr('href');
        $(_curPop).stop().slideToggle(200);
        return false;
      });
      /*  $('.pop-bg').click(function(e) {
           e.stopPropagation();
           $(this).parents('.m-pop').stop().slideUp(200);
       }); */
      if (_winw > 768) {
        $('body,html').click(function (e) {
          $('#win1').stop().slideUp(200);

        });
        $('#win1').click(function (e) {
          // $('#win1').stop().slideDown();

          return false;
        });
      }

      $('.m_pop .close').click(function (e) {
        e.preventDefault();

        $('.m_pop').stop().fadeOut(200);
      });

      $('.nav .cont a,.footer .lk .cont a').click(function (e) {
        e.preventDefault();

        $('.m_pop').stop().fadeIn(200);
      });


      if (window.WOW) {
        var wow = new WOW({
          boxClass: 'wow',
          animateClass: 'animated',
          offset: 0,
          mobile: true,
          live: true
        });
        wow.init();
      }

      $('.share').click(function () {
        $('.share_img').toggleClass('share_dis')
      })

      var link = document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = '/images/bitbug_favicon.ico';
      document.getElementsByTagName('head')[0].appendChild(link);
    });


  }
}
</script>
<style lang="less">

* {
  text-decoration: none;
}

.aaaa {
  display: none;
}

#nav-bac {
  width: 68%;
  margin: 0 auto;
  @media screen and(max-width: 1800px) {
    width: 75%;
  }
  @media screen and(max-width: 1620px) {
    width: 88%;
  }
  @media screen and(max-width: 1360px) {
    width: 90%;
  }
  @media screen and(max-width: 1270px) {
    width: 95%;
  }
  @media screen and(max-width: 875px) {
    width: 100%;
  }
  @media screen and(max-width: 769px) {
    background-color: transparent !important;
    width: 100%;
  }
}

.my-nav {
  // height: 140px;
  #bacright {
    @media screen and(max-width: 767px) {
      width: 40%;
      float: right;
      margin-right: 0px;
      background-color: #268DFF;
    }
  }

  background-color: #268DFF;
  position: fixed;
  @media screen and(max-width: 767px) {
    background-color: transparent ;
  }
  width: 100%;
  z-index: 99999;
  top: 0;

  .navbar.navbar-default {
    background-color: #268DFF;
    border: none;

    .navbar-header {
      background-color: #268DFF;
      /*!******************************
          -------[=导航]-------
      ********************************/

      .menuBtn {
        display: none;
        position: absolute;
        z-index: 999;
        top: 12px;
        right: 12px;
        width: 30px;
        height: 30px;
        cursor: pointer;
        transition: .3s;
        -ms-transition: .3s;
        -moz-transition: .3s;
        -webkit-transition: .3s;
        -o-transition: .3s
      }

      .menuBtn b {
        display: block;
        height: 4px;
        background-color: #000;
        margin: 4px 0;
        transition: .3s;
        -ms-transition: .3s;
        -moz-transition: .3s;
        -webkit-transition: .3s;
        -o-transition: .3s
      }

      .menuBtn b {
        background-color: #fff
      }

      .menuBtn.open b {
        display: none;
        margin: -5px 0 0;
        position: absolute;
        left: 0;
        top: 50%;
        width: 30px
      }

      .menuBtn.open b:first-child {
        display: block;
        -moz-transform: rotate(45deg);
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        -ms-transform: rotate(45deg)
      }

      .menuBtn.open b:last-child {
        display: block;
        -moz-transform: rotate(-45deg);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg)
      }

      @media screen and (max-width: 767px) {
        .headSty .header::before {
          display: none;
        }

        .headSty .header,
        .header {
          height: 50px;
          border-bottom: 1px solid rgba(255, 255, 255, .14);
          background-color: #fff;
        }

        .header .wp {
          border-bottom: none
        }

        .logo {
          line-height: 50px
        }

        .logo img {
          max-height: 30px
        }

        .menuBtn {
          display: block
        }

        .hd-body {
          display: none;
          position: fixed;
          top: 50px;
          bottom: 0;
          left: 0;
          width: 100%;
          background-color: rgba(0, 0, 0, .7)
        }

        .hr {
          line-height: 40px;
          margin-left: 0
        }

        .hr, .nav, .nav li {
          float: none;
          width: auto
        }

        .headSty .nav .v1,
        .nav .v1 {
          line-height: 40px
        }

        .nav .act .v1 {
          border-width: 1px
        }

        .headSty .nav {
          margin-top: 0;
          padding-top: 20px;
        }

        .nav {
          padding-top: 20px;
          max-height: calc(100vh - 140px);
          overflow-y: auto;
          // @media screen and(max-width:767px){
          //   background-color: #C4243E;
          //   width: 40;
          //   overflow: hidden;
          //   float: right;
          // }
        }

        //
        .hr, .nav li {
          padding: 0 10px
        }

        .hr .so {
          display: none
        }

        .m-pop {
          position: static;
          display: block
        }

        .pop-bg {
          display: none
        }

        .m-pop .inner {
          position: relative;
          top: 0;
          left: 0;
          width: 100%;
          transform: none;
        }

        .m-pop .inner .inp, .m-pop .inner .submit {
          font-size: 14px;
          height: 45px;
          padding-right: 45px
        }

        .m-pop .inner .submit {
          width: 40px;
          line-height: 45px
        }

        .sub .v2 {
          background-color: transparent;
          text-align: left;
          padding-left: 15px;
        }

        .sub .drop .v2 {
          padding-left: 30px;
        }

        .sub .third .drop,
        .sub {
          position: static;
          width: auto;
          margin-left: 0;
        }

        .nav .v1 {
          overflow: hidden;
          margin: 0;
        }

        .dropIcon {
          display: block;
        }

        .on > .dropIcon {
          transform: rotate(180deg);
        }

        .banner .txt h3 {
          font-size: 16px
        }

        .banner .txt .en {
          font-size: 14px
        }
      }
    }
  }

  .navbar-default {

  }

  .navbar-default .navbar-nav > li > a {
    width: 220px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and(max-width: 1800px) {
      width: 220px;
      font-size: 20px;
    }
    @media screen and(max-width: 1695px) {
      width: 220px;
      font-size: 20px;
    }
    @media screen and(max-width: 1550px) {
      width: 220px;
      font-size: 20px;
    }
    @media screen and(max-width: 1360px) {
      width: 200px;
      font-size: 17px;
    }
    @media screen and(max-width: 1270px) {
      width: 200px;
      font-size: 16px;
    }
    @media screen and(max-width: 1100px) {
      width: 190px;
      font-size: 12px;
    }
    @media screen and(max-width: 950px) {
      width: 180px;
      font-size: 12px;
    }
    @media screen and(max-width: 910px) {
      width: 180px;
      font-size: 12px;
    }
    @media screen and(max-width: 880px) {
      width: auto;
      font-size: 12px;
    }
    @media screen and(max-width: 769px) {
      font-size: 12px;
    }
  }

  .navbar-default .navbar-nav > li.active a {
    background-color: #268DFF;

    @media screen and (max-width: 769px) {
      font-size: 12px;
      background-color: #f2f2f2;
      opacity: 15;
      color: #268DFF;
    }

  }

  .navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:focus, .navbar-default .navbar-nav > .open > a:hover {
    color: #268DFF;
  }

  .navbar-default .navbar-nav > .active > a {
    color: #eee;
  }

  .navbar {
    // min-height: 70px;

    margin-bottom: 0px;
  }

  .router-link-active {
    text-decoration: none !important;
  }

  .navbar-brand {
    font-size: 30px;
    color: #eee;
    height: 80px;
    margin-right: 20px;
    // font-style:italic;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    @media screen and (max-width: 1024px) {
      height: 70px;
      display: block;
    }

    @media screen and(max-width: 769px) {
      font-size: 10px;
      height: 66px;
    }
    @media screen and(max-width: 768px) {
      margin-top: 6px;
      font-size: 10px;
      height: 66px;
    }
    @media screen and(max-width: 767px) {
      margin-top: 0px;
      font-size: 10px;
      height: 66px;
    }
    @media screen and(max-width: 760px) {
      font-size: 10px;
      height: 50px;
    }

    &:hover {
      color: #eee;
    }

    .logo {
      margin-right: 10px;
      // position: absolute;
      // left: 10%;
      // width: 80px;
      // height: 30px;
      // line-height: 70px;
      // margin-top: -5px;
      width: 65px;
      // height: 50px;
      @media screen and(max-width: 1620px) {
        width: 50px;
        // height: 50px;
      }
      @media screen and(max-width: 1200px) {
        width: 45px;
        // height: 50px;
      }
      @media screen and(max-width: 1024px) {
        width: 42px;
        // height: 50px;
      }
      @media screen and(max-width: 769px) {
        margin-top: -8px;
        width: 40px;
        // height: 24px;
      }
    }

    .brand-span {
      font-size: 18px;
      color: #eee;
      border: none;
      @media screen and(max-width: 1620px) {
        font-size: 18px;
      }
      @media screen and(max-width: 1200px) {
        font-size: 1.4rem;
      }
      @media screen and(max-width: 769px) {
        font-size: 1rem;
      }
    }
  }

  .navbar-right {
    ul.link {
      display: flex;
      -webkit-display: flex;
      -moz-display: flex;
      -o-display: flex;
      align-items: center;
      min-height: 50px;
      margin-right: 16px;

      li {
        width: 18px;
        margin: 0 8px;

        img {
          display: block;
          width: auto;
          height: auto;
          margin: 0 auto;
        }
      }

      // 中等屏幕时隐藏
      @media screen and (min-width: 769px) and (max-width: 992px) {
        display: none;

      }
    }
  }

  // 适配pc端导航
  @media screen and (min-width: 835px) {
    .mycustom {
      // display: flex;
      // justify-content: space-between;
      width: 100%;


    }

    #bs-example-navbar-collapse-1 {
      // margin-left: 360px;
      float: right;

      & > ul {
        font-size: 24px;

        & > li > a {
          // height:70px !important;
          // line-height:70px !important ;


        }
      }
    }

    .navbar-header > a {
      // padding:22px 15px;
      background-color: #268DFF;

      img {
        height: auto;
      }
    }

    ul.link {
      height: 70px;
      // height: 140px;//
    }
  }
}

.navbar-default .navbar-nav > li > a {
  padding: 25px 40px;
  width: 100%;
  color: #fff;
  border-bottom: transparent solid 3px;
  // height: 70px;
  height: 80px;
  transform: scale(1);
  box-sizing: border-box;
  font-size:20px;
  @media screen and(max-width: 1400px) {
    padding: 25px 30px;
  }
  @media screen and(max-width: 815px) {
    padding: 25px 25px;
  }
  // @media screen and (max-width:858px){
  //  height:100px;
  // }
  @media screen and (max-width: 1024px) {
    height: 70px;
  }
  @media screen and (max-width: 769px) {
    height: 70px;
  }
}

.navbar-default .navbar-nav > li > a:hover {
  color: #FFFFFF;
  // transform: scale(1.16);
  // font-size: 14px;
  // @media screen and(max-width: 1800px) {
  //   font-size: 14px;
  // }
  // @media screen and(max-width: 1695px) {
  //   font-size: 14px;
  // }
  // @media screen and(max-width: 1550px) {
  //   font-size: 14px;
  // }
  // @media screen and(max-width: 1360px) {
  //   font-size: 14px;
  // }
  // @media screen and(max-width: 1270px) {
  //   font-size: 14px;
  // }
  // @media screen and(max-width: 950px) {
  //   font-size: 14px;
  // }
  // @media screen and(max-width:1550px){
  //   font-size: 24px;
  // }
  // @media screen and(max-width:1360px){
  //   font-size: 23px;
  // }
  // @media screen and(max-width:1270px){
  //   font-size: 20px;
  // }
  // @media screen and(max-width:769px){
  //   font-size: 14px;
  // }
  // font-size: 16px;
}

.navbar-default .navbar-nav > li.active a {
  background-color: transparent;
  color: #FFFFFF;
  // font-size: 16px;
  // font-size: 30px;//
  // transform: scale(1.16);
  // transform: scaleY(1);
  font-size: 20px;
  @media screen and(max-width: 1800px) {
    font-size: 20px;
  }
  @media screen and(max-width: 1695px) {
    font-size: 20px;
  }
  @media screen and(max-width: 1550px) {
    font-size: 20px;
  }
  @media screen and(max-width: 1360px) {
    font-size: 17px;
  }
  @media screen and(max-width: 1270px) {
    font-size: 16px;
  }
  @media screen and(max-width: 1100px) {
    font-size: 12px;
  }
  border-bottom: #FFFFFF solid 3px;
  @media screen and (max-width: 769px) {
    border-bottom: #FFFFFF solid 0px;
    font-size: 16px;//
  }
}

& > ul {
  & > li > a {
    // height:70px !important;
    // line-height:70px !important ;

    padding: 25px 0;
    width: 140px;
    text-align: center;
  }
}

#bs-example-navbar-collapse-1 /deep/ {
  background-color: transparent !important;
}
</style>
